<script>
    import images from './images.js';
    import PageTextLine from './PageTextLine.svelte';
    import Italic from './Italic.svelte';
    import PlusMinusStat from './PlusMinusStat.svelte';
    import GlossaryLink from './GlossaryLink.svelte';
    import Link from './Link.svelte';
    import Die from './Die.svelte';

    export let lines = [];
    export let state;
    const Text = Symbol('plaintext chunk');
    const inlineTagRegex = new RegExp(`\\[(link: [^\\]]+|italic: [^\\]]+|glossary: [^\\]]+|die|${Object.keys(images).join('|')})\\]|([+-])([0-9]+) ((healthmin1)|(health)|(impact)\\b)`, 'i');
    const inlineSplitRegex = new RegExp(`(\\[(?:link: [^\\]]+|italic: [^\\]]+|glossary: [^\\]]+|die|${Object.keys(images).join('|')})\\]|[+-][0-9]+ (?:healthmin1|health|impact)\\b)`, 'ig');
    const parseLine = (line) => {
        const filtered = line.replace(/\[current impact\]/g, `${state.impact}`).replace(/\[10 - impact\]/g, `${10 - state.impact}`).replace(/\[impact gained\/lost\]/g, (state.impact > state.startingImpact) ? 'gained' : 'lost');
        const chunks = filtered.split(inlineSplitRegex);
        const typedChunks = [];
        chunks.forEach((chunk, i) => {
            if ((i % 2) === 0) {
                typedChunks.push([Text, chunk]);
            } else {
                const [, shortcode, sign, number, , healthMin1, health, impact] = chunk.match(inlineTagRegex);
                if (shortcode) {
                    if (shortcode.startsWith('link: ')) {
                        const [, url, ...label] = shortcode.split(/\s+/);
                        typedChunks.push([Link, url, label.join(' ')]);
                    } else if (shortcode.startsWith('italic: ')) {
                        typedChunks.push([Italic, shortcode.substr(8)]);
                    } else if (shortcode.startsWith('glossary: ')) {
                        typedChunks.push([GlossaryLink, shortcode.substr(10)]);
                    } else if (shortcode === 'die') {
                        typedChunks.push([Die]);
                    } else if (images[shortcode]) {
                        typedChunks.push([images[shortcode]]);
                    } else {
                        console.log(`unknown shortcode "${shortcode}"`);
                    }
                } else {
                    const inNumber = parseInt(number);
                    const signed1 = sign === '-' ? -1 : 1;
                    const fixedNumber = healthMin1 ? (Math.max(1 - state.healthPreMin1, signed1 * inNumber) * signed1) : inNumber
                    typedChunks.push([PlusMinusStat, sign, (health ?? healthMin1) ? 'health' : 'impact', parseInt(fixedNumber)])
                }
            }
        });
        // wrap ret so we can set the type of the outer block
        const ret = {type: 'p', zoom: false, chunks: typedChunks};
        const types = [
            {slug: 'zoom', class: 'zoom'},
            {slug: 'small', class: 'small'},
            {slug: 'big', tag: 'h3'},
            {slug: 'bigger', tag: 'h2'},
            {slug: 'biggest', tag: 'h1'},
            {slug: 'biggest tagline', tag: 'h3', class: 'tagline'},
            {slug: 'underlined', class: 'underlined'},
            {slug: 'centered', class: 'centered'},
        ];
        const classes = [];
        if (typedChunks.length > 0 && typedChunks[0][0] === Text) {
            const first = typedChunks[0];
            for (let i = 0, lastMatchI = -1; i <= lastMatchI + types.length; i++) {
                const type = types[i % types.length];
                const prefix = `[${type.slug}] `;
                if (first[1].startsWith(prefix)) {
                    lastMatchI = i;
                    first[1] = first[1].substr(prefix.length);
                    if (type.class) {
                        classes.push(type.class)
                    }
                    if (type.tag) {
                        ret.tag = type.tag
                    }
                }
            }
        }
        ret.classes = classes.join(' ');
        return ret;
    }
    let parsedLines;
    $: parsedLines = lines.map(parseLine);
</script>


{#each parsedLines as line}
    <PageTextLine {line}>{#each line.chunks as chunk, i}{#if chunk[0] === Text}{chunk[1]}{:else}<svelte:component this={chunk[0]} args={chunk.slice(1)}/>{/if}{/each}</PageTextLine>
{/each}
